'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.js');
var index = require('../node_modules/@material-ui/system/esm/index.js');

var require$$0 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(index);

module.exports = require$$0;
